import doRequest from "../helpers";
import { getToken } from "../auth/tokenAuth";
//#region Utils
import { base64ToBlob } from "utils/conversions";
import { EVENTS_CONSTANTS } from "config/constants";
//#endregion

export const requestGetEventTypes = async () => {
    const [result, err] = await doRequest(
        "/TipoEvento", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.listTipoEvento.map(({
        idTipoEvento,
        nombre, icono
    }) => {
        return {
            id: idTipoEvento, 
            name: nombre, 
            icon: base64ToBlob(icono, "image/svg+xml")
        };
    });
}
export const requestGetEventSubtypes = async () => {
    const [result, err] = await doRequest(
        `/SubTipoEvento`, "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.listSubTipoEvento.map(({ 
        idSubTipoEvento,
        idTipoEvento, 
        nombre 
    }) => ({
        id: idSubTipoEvento, 
        name: nombre, 
        eventTypeId: idTipoEvento
    }));
}
export const requestGetEventGraphics = async () => {
    const [result, err] = await doRequest(
        "/GraficaEvento", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.listGraficaEvento.map(({
        graficaEventoId,
        idTipoEvento, 
        idSubTipoEvento,
        nombre, 
        urlImagen
    }) => {
        return {
            id: graficaEventoId,
            eventTypeId: idTipoEvento,
            eventSubtypeId: idSubTipoEvento,
            name: nombre,
            image: urlImagen
        };
    });
}
export const requestGetComplementaryServiceAreas = async () => {
    const [result, err] = await doRequest(
        "/AreaServicioComplementario", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.listServiceComplement.map(({
        idAreaServicioPorTipoEvento: id,
        idTipoEvento: eventTypeId,
        nombre: name
    }) => {
        return {
            id, eventTypeId, name
        };
    });
}
export const requestGetOrganizers = async () => {
    const [result, err] = await doRequest(
        `/Organizador`, "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.listOrganizador.map(({
        idOrganizador,
        nombre 
    }) => {
        return {
            id: idOrganizador, 
            name: nombre 
        };
    }); 
}

const RESTRICTED_STATES = [
    EVENTS_CONSTANTS.FORM_ACTION_ERROR_CODES.PENDING_INVITATION_OF_ZOOM_ACCOUNT
];
export const requestGetTeacherZoomAccountDetail = async ({
    teacherId,
    teacherAccountId
}) => {
    const [result, err] = await doRequest(
        "/Evento/DetalleCuentaZoom", "POST", 
        {
            codigoUsuario: teacherId,
            idCuentaDocente: teacherAccountId
        }, getToken());
    if (err)
        return null;
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return {
            zoomTypeId: 0,
            guests: 0,
            state: data.data.mensaje
        };
    const { DetalleCuenta } = data.data;
    const state = DetalleCuenta.estadoCuenta;
    const isError = RESTRICTED_STATES.includes(state);
    return {
        zoomTypeId: isError ? 0 : DetalleCuenta?.idTipoZoom,
        guests: isError ? 0 : DetalleCuenta?.invitados,
        state
    };
}

export const requestGetExtracurricularSections = async () => {
    const [result, err] = await doRequest(
        `/SeccionExtracurricular`, "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.listSeccionExtracurricular.map(({ 
        seccionExtracurricularId,
        courseId, 
        courseCode,
        courseName,
        sectionId,
        sectionCode,
        classNumber,
        activo,
        idSubTipoEvento,
        visible
    }) => ({
        seccionExtracurricularId : seccionExtracurricularId,
        courseId : courseId, 
        courseCode : courseCode,
        courseName : courseName,
        sectionId : sectionId,
        sectionCode : sectionCode,
        classNumber : classNumber,
        activo : activo,
        idSubTipoEvento : idSubTipoEvento,
        visible: visible
    }));
}